import { render, staticRenderFns } from "./SampleBlockList.vue?vue&type=template&id=13e00336&scoped=true&"
import script from "./SampleBlockList.vue?vue&type=script&lang=js&"
export * from "./SampleBlockList.vue?vue&type=script&lang=js&"
import style0 from "./SampleBlockList.vue?vue&type=style&index=0&id=13e00336&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e00336",
  null
  
)

export default component.exports